module.exports = __webpack_public_path__ + "img/8789a42.svg";